import { GrowthBook } from '@growthbook/growthbook';

export type GrowthBookFeaturesFlag = {
  'portal-injectJs'?: boolean;
  'platform-multimedia-image-config'?: {
    rotate: boolean;
    zoom: boolean;
    aspect: boolean;
    rotate360: boolean;
  };
  'podEnv-supported'?: {
    vymoWeb: Array<string>;
    selfserve: Array<string>;
    webPlatform: Array<string>;
  };
  'dashboard-admin'?: boolean;
  'invalidate-cdn'?: boolean;
  'enable-webInit-forAllHost'?: boolean;
  'enable-v1-tokens'?: boolean;
  'enable-visitor-token-check'?: boolean;
  'enable-spg'?: boolean;
  'enable-copilot-platform'?: boolean;
  'enable-user-profile-platform'?: boolean;
  'allow-new-communication-banner'?: boolean;
  'disable-entity-payload'?: boolean;
  'enable-new-legacy-leads-list'?: boolean;
  'enable-performance-dashboard'?: boolean;
  'enable-details-360'?: boolean;
  'revyre-returnCode'?: boolean;
};
export const featureFlagKeys: Array<keyof GrowthBookFeaturesFlag> = [
  'portal-injectJs',
  'platform-multimedia-image-config',
  'podEnv-supported',
  'dashboard-admin',
  'invalidate-cdn',
  'enable-webInit-forAllHost',
  'enable-v1-tokens',
  'enable-visitor-token-check',
  'enable-spg',
  'enable-copilot-platform',
  'enable-user-profile-platform',
  'allow-new-communication-banner',
  'disable-entity-payload',
  'enable-new-legacy-leads-list',
  'enable-performance-dashboard',
  'enable-details-360',
  'revyre-returnCode',
];

const attributes = {
  clientCode: '',
  userEmail: '',
};

export const growthbook = new GrowthBook({
  attributes,
  enableDevMode: process.env.NODE_ENV !== 'production',
});

export const getGrowthBookFeatureFlag = <
  K extends keyof GrowthBookFeaturesFlag,
>(
  featureFlag: K,
): GrowthBookFeaturesFlag[K] =>
  growthbook.getFeatureValue(featureFlag, false) as any;
